export function convertDateToUTC(date: Date) {
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
}

export function fromDateTimeToDateOnly(date: Date): string {
  if (!date) return "";
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear().toString();
  return [year, month, day].join("-");
}
